module.exports = __webpack_public_path__ + "7cde02aff9601befedad1510855880e2.jpg";